import styled from "styled-components";

export const HTMLBarChartContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(5px, 1fr));
  grid-template-rows: 1fr;
  .bar-group {
    display: flex;
    align-items: end;
    .bar {
      background: #D3D3D3;
      width: 100%;
    }
  }
`

export const HTMLBarsContainer = styled.div<{ bar_width?: number }>`
  position: relative;
  display: grid;
  
  width: 100%;
  height: 100%;

  .bar-group {
    display: flex;
    align-items: center;
  
    bottom: 0;
    position: absolute;
    flex-direction: column;
    justify-content: flex-end;
    &:hover { cursor: pointer; }
    &:not(:hover) {
      .is-not-selected  {
        &.bar { background-color:#D3D3D3!important; }
      }    
    }
  }

  &.vertical {
    .bar-group {
      align-items: start;
      justify-content: center;
      flex-direction: row;
    }
  }

  .bar {
    transition: background-color 0.3s ease, filter 0.3s ease;
    &:hover { 
      cursor: pointer;
      filter: brightness(130%);  
    }
    &.is-filtered {
      height: 0!important;
    }
  }
`